export default __webpack_public_path__ + "c1aa41d80bd39cf73f580b16565e2812.png";